import { ProductTypeError } from './product-type-form';

export function normalizeProgramName(value: string): string {
  const name = typeof value === 'string' ? value.trim() : '';
  if (!name) {
    throw new ProductTypeError('validation', 'El nombre del programa es obligatorio.');
  }
  if (name.length > 200) {
    throw new ProductTypeError('validation', 'El nombre no puede superar 200 caracteres.');
  }
  return name;
}

export function normalizeProgramStatus(value: number): 1 | 2 {
  if (value !== 1 && value !== 2) {
    throw new ProductTypeError('validation', 'Selecciona un estado válido.');
  }
  return value;
}

export function programChanged(name: string, status: number, originalName: string,
  originalStatus: number): boolean {
  return normalizeProgramName(name) !== normalizeProgramName(originalName) ||
    normalizeProgramStatus(status) !== normalizeProgramStatus(originalStatus);
}



// WEBPACK FOOTER //
// ./src/utils/program-form.ts